<template>
  <div
    class="bg-background-neutral-secondary flex flex-col items-center space-y-3 rounded-2xl p-4 text-center"
  >
    <div
      class="bg-background-neutral-primary flex h-[72px] w-[72px] items-center justify-center rounded-full"
    >
      <img
        src="../../../assets/images/pointer.svg"
        width="48"
        height="48"
        alt=""
      />
    </div>
    <h2 class="text-text-neutral-primary text-base font-semibold">
      {{ t('emptyResults') }}
    </h2>
    <p class="text-text-neutral-tertiary text-sm">
      {{ t('tryAgain') }}
    </p>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import messages from '../locales.json';

  const { t } = useI18n({ messages });
</script>
